import { render, staticRenderFns } from "./ChangeCodeModal.vue?vue&type=template&id=48520ef2"
import script from "./ChangeCodeModal.vue?vue&type=script&lang=ts"
export * from "./ChangeCodeModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports